import { render, staticRenderFns } from "./add-tenancy.vue?vue&type=template&id=2de2dfa3&scoped=true&"
import script from "./add-tenancy.vue?vue&type=script&lang=js&"
export * from "./add-tenancy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de2dfa3",
  null
  
)

export default component.exports